import { IdleQueue } from 'idlize/IdleQueue.mjs';

export const appQueue = new IdleQueue();
